import React, { useCallback } from 'react';
import get from 'lodash/get';
import { useApolloClient } from '@apollo/react-hooks';
import query from 'queries/supplier/search-suppliers.graphql';
import SelectInput from './AsyncSearchSelectInput';

export default function SupplierInput(props) {
  let { mode, value, isStore, ...rest } = props;

  let apollo = useApolloClient();

  let searchByKeyword = useCallback(
    async name => {
      let result = await apollo.query({
        query,
        variables: {
          limit: 10,
          where: {
            name: {
              _ilike: `%${name}%`
            },
            is_store: isStore
              ? {
                  _eq: true
                }
              : undefined
          }
        }
      });

      return get(result, 'data.result', []).map(supplier => ({
        label: supplier.name,
        value: supplier.id
      }));
    },
    [apollo, isStore]
  );

  let searchByValue = useCallback(
    async ids => {
      let result = await apollo.query({
        query,
        variables: {
          where: {
            id: {
              _in: ids
            },
            is_store: isStore
              ? {
                  _eq: true
                }
              : undefined
          }
        }
      });

      return get(result, 'data.result', []).map(supplier => ({
        label: supplier.name,
        value: supplier.id
      }));
    },
    [apollo, isStore]
  );

  return (
    <SelectInput
      mode={mode}
      searchByValue={searchByValue}
      searchByKeyword={searchByKeyword}
      value={value}
      {...rest}
    />
  );
}

SupplierInput.defaultProps = {
  allowClear: true
};
